export const stringLinesToArray = (string = "") =>
  string
    .replaceAll(",", "\n")
    .replaceAll(" ", "\n")
    .replaceAll('"', "")
    .replaceAll("'", "")
    .split("\n")
    .filter((element) => element !== "" && element.length > 4)
    .map((element) => element.trim());

export const getDiference = ({ source, toRemove }) => {
  const toRemoveSet = new Set(toRemove);
  return source.filter((element) => !toRemoveSet.has(element));
};

export const unique = (array) => [...new Set(array)];
